import {
  RowFields,
  Field,
  Widget,
  ValidationItems,
} from '@kanda-libs/ks-component-ts';
import { BreakPoints, Text } from '@kanda-libs/ks-design-library';

import { ACCOUNT_NUMBER_VALIDATION, PROPS, ERROR_PROPS } from './constants';
import useBankFields from './useBankFields';

const BankDetailsFields = () => {
  const { error, timeValidation, sortCodeValidation } = useBankFields();

  return (
    <>
      <Text {...PROPS.title} />
      <Text {...PROPS.description} />
      <div {...PROPS.card}>
        <BreakPoints
          mobile={
            <>
              <Widget.CreditBankAccountAccountName placeholder="Holder's name" />
              <RowFields>
                <Widget.CreditBankAccountAccountNumber
                  placeholder="Account number"
                  validation={ACCOUNT_NUMBER_VALIDATION}
                />
                <Widget.CreditBankAccountSortCode
                  validation={sortCodeValidation as unknown as ValidationItems}
                  type="sortCode"
                  placeholder="00-00-00"
                />
              </RowFields>
            </>
          }
          desktop={
            <RowFields leftAligned>
              <div className="max-w-44">
                <Widget.CreditBankAccountAccountName placeholder="Holder's name" />
              </div>
              <RowFields>
                <Widget.CreditBankAccountAccountNumber
                  placeholder="Account number"
                  validation={ACCOUNT_NUMBER_VALIDATION}
                />
                <Widget.CreditBankAccountSortCode
                  validation={sortCodeValidation as unknown as ValidationItems}
                  type="sortCode"
                  placeholder="00-00-00"
                />
              </RowFields>
            </RowFields>
          }
        />

        <Text
          text="How long have you held this bank account?"
          className="w-full mb-2 text-style-h-em text-neutral-600"
        />
        <RowFields leftAligned>
          <div className="max-w-28">
            <Field.NumberInput {...PROPS.accountYearsOwned} />
          </div>
          <div className="max-w-28">
            <Field.NumberInput {...PROPS.accountMonthsOwned} />
          </div>
        </RowFields>
        {error && <Text text={error} className={ERROR_PROPS.className} />}
        <div className="hidden">
          <Widget.CreditBankAccountMonthsHeld
            validation={timeValidation as unknown as ValidationItems}
          />
        </div>
        <div className="mt-6" />
        <Field.BooleanInput {...PROPS.confirmAccount} />
        <Field.BooleanInput {...PROPS.iva} />
      </div>
    </>
  );
};

export default BankDetailsFields;
